export default "__VITE_ASSET__DbN7$WeP__"